import { computed, Directive, forwardRef, inject, input } from '@angular/core';
import { SLIDE_BUILDER_BACKGROUND_CONTEXT } from '../../common/constants';
import { SlideBackgroundData } from '../../common/models';

@Directive({
  selector: '[slideBackgroundContext]',
  providers: [
    {
      provide: SLIDE_BUILDER_BACKGROUND_CONTEXT,
      useFactory: (directive: SlideBackgroundContextDirective) => directive.backgroundContext,
      deps: [forwardRef(() => SlideBackgroundContextDirective)]
    }
  ],
  standalone: false
})
export class SlideBackgroundContextDirective {
  private readonly parentBackgroundContext = inject(SLIDE_BUILDER_BACKGROUND_CONTEXT, { optional: true, skipSelf: true });

  public readonly slideBackgroundContext = input<Partial<SlideBackgroundData> | null>(null);
  
  public readonly backgroundContext = computed(() => {
    const parentBackgroundContext = this.getBackgroundContext(this.parentBackgroundContext?.() ?? {});
    const backgroundContext = this.slideBackgroundContext() || {};

    const { enableBackground, backgroundColor, mediaBackground } = backgroundContext;
    const hasBackground = enableBackground ? backgroundColor || mediaBackground : false;

    return hasBackground ? backgroundContext : parentBackgroundContext;
  });

  private getBackgroundContext(value: Partial<SlideBackgroundData>): Partial<SlideBackgroundData> {
    return {
      enableBackground: value.enableBackground,
      backgroundColor: value.backgroundColor,
      mediaBackground: value.mediaBackground
    };
  }
}
